<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Reporting
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>
          <el-form :model="form" label-position="top" size="mini" :rules="rules" status-icon ref="form">
            <el-row :gutter="20">
              <el-col :span="14" :offset="0">
                <el-row :gutter="50">
                  <el-col :span="12">
                  </el-col>
                  <el-col :span="12" style="margin-left: 50%">
                    Tax Agent Acc. No./Atty's Roll No. (if applicable)
                  </el-col>
                </el-row>
                <el-row :gutter="50" style="margin-top: 20px;">
                  <el-col :span="12">
                    <el-form-item
                        label="Organisation Classification (Sales Tax)"
                        prop="OCSalesTax"
                        size="mini">
                      <el-select
                          style="width: 100%"
                          no-data-text="no date"
                          v-model="form.OCSalesTax"
                          :disabled="true"
                          placeholder="">
                        <el-option
                            v-for="item in entityTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                        label="Organisation Classification (Income Tax)"
                        prop="taxpayerClassificationId"
                        size="mini">
                      <el-select
                          style="width: 100%"
                          no-data-text="no date"
                          v-model="form.taxpayerClassificationId"
                          placeholder="Corporation or Partnership">
                        <el-option
                            v-for="item in taxpayerClassifications"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <div style="display: flex; align-items: center; column-gap: 10px;">
                        <el-radio-group v-model="form.isPsic">
                          <el-radio :label="1">Line of Business (PSIC)</el-radio>
                          <el-radio :label="0">Occupation (PSOC)</el-radio>
                        </el-radio-group>
                      </div>
                    </el-form-item>
                    <el-form-item
                        v-if="form.isPsic === 1"
                        label="Line of Business (PSIC)"
                        prop="psicId"
                        size="mini">
                      <el-select
                          style="width: 100%"
                          no-data-text="no date"
                          v-model="form.psicId"
                          placeholder="Line of Business (PSIC)">
                        <el-option
                            v-for="item in psics"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                        v-else
                        label="Occupation (PSOC)"
                        prop="psocId"
                        size="mini">
                      <el-select
                          style="width: 100%"
                          no-data-text="no date"
                          v-model="form.psocId"
                          placeholder="Occupation (PSOC)">
                        <el-option
                            v-for="item in psocs"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                        label="Filling Method"
                        prop="fillingMethodId"
                        size="mini">
                      <el-select
                          style="width: 100%"
                          no-data-text="no date"
                          v-model="form.fillingMethodId"
                          placeholder="EBIR Forms">
                        <el-option
                            v-for="item in fillingMethods"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <h4 style="margin-top: 30px;">Report Settings</h4>
                    <div style="margin-bottom: 20px;">
                      (President/Vice President/Principal Officer/Accredited Tax Agent/Authorized Representative/Taxpayer)
                    </div>
                    <el-form-item
                        label="Name"
                        prop="settingsName"
                        size="mini">
                      <el-input v-model="form.settingsName" placeholder="Name"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="Title/Position of Signatory"
                        prop="titlePositionOfSignatory"
                        size="mini">
                      <el-input v-model="form.titlePositionOfSignatory" placeholder="Title/Position of Signatory"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="TIN of Signatory"
                        prop="tinOfSignatory"
                        size="mini">
                      <el-input v-model="form.tinOfSignatory" placeholder="TIN of Signatory"></el-input>
                    </el-form-item>
                    <div style="margin-top: 30px; margin-bottom: 30px;">
                      (Treasurer/Assistant Treasurer)
                    </div>
                    <el-form-item
                        label="Name"
                        prop="treasurerName"
                        size="mini">
                      <el-input v-model="form.treasurerName" placeholder="Name"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="Title/Position of Signatory"
                        prop="treasurerPositionOfSignatory"
                        size="mini">
                      <el-input v-model="form.treasurerPositionOfSignatory" placeholder="Title/Position of Signatory"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="TIN of Signatory"
                        prop="treasurerTinOfSignatory"
                        size="mini">
                      <el-input v-model="form.treasurerTinOfSignatory" placeholder="TIN of Signatory"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                        label="Name"
                        prop="agentName"
                        size="mini">
                      <el-input v-model="form.agentName" placeholder="Name"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="Date of Issuance"
                        prop="dateOfIssuance"
                        size="mini">
                      <el-date-picker
                          v-model="form.dateOfIssuance"
                          type="date"
                          format="d MMM yy"
                          value-format="ddMMyyyy"
                          placeholder="Date of Issuance"
                          style="width: 100%;">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item
                        label="Date of Expiry"
                        prop="dateOfExpiry"
                        size="mini">
                      <el-date-picker
                          v-model="form.dateOfExpiry"
                          type="date"
                          format="d MMM yy"
                          value-format="ddMMyyyy"
                          placeholder="Date of Expiry"
                          style="width: 100%;">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                      <div style="display: flex; align-items: center; column-gap: 10px;">
                        <el-switch v-model="form.branchOffices"></el-switch>Branch Offices
                      </div>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                          style="width: 200px"
                          size="mini"
                          type="primary"
                          :disabled="!form.branchOffices"
                          @click="openBranchOfficeModal"
                      >Open Branch Office Table</el-button>
                    </el-form-item>
                    <h4 style="margin-top: 40px; margin-bottom: 40px">BIR Filing Tables</h4>
                    <el-form-item>
                      <el-button
                          style="width: 200px"
                          size="mini"
                          type="primary"
                          @click="openFillingModal('71')"
                      >VAT/Percentage</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                          style="width: 200px"
                          size="mini"
                          type="primary"
                          @click="openFillingModal('72')">
                        Withholding Tax</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                          style="width: 200px"
                          size="mini"
                          type="primary"
                          @click="openFillingModal('73')">
                        Income Tax</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                          style="width: 200px"
                          size="mini"
                          type="primary"
                          @click="openFillingModal('74')"
                          >Branch Office Forms</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                          style="width: 200px"
                          size="mini"
                          type="primary"
                          @click="openFillingModal('75')">
                        Misc/Others
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-button type="primary" @click="save">Save</el-button>
          </el-form>
        </div>
      </div>
    </div>
    <filling-tables-modal
      ref="fillingModal"/>
    <branch-office-modal
      ref="branchOfficeModal"/>
  </div>
</template>

<script>
import axios from 'axios'
import FillingTablesModal from "../../../components/settings/organizationInformation/FillingTablesModal";
import BranchOfficeModal from "../../../components/settings/organizationInformation/BranchOfficeModal";

export default {
  name: "InformationReport",
  components: {
    BranchOfficeModal,
    FillingTablesModal
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    }
  },
  data() {
    return {
      form: {
        taxpayerClassificationId: null,
        psicId: null,
        psocId: null,
        fillingMethodId: null,
        //
        isPsic: 1,
        //
        agentName: null,
        dateOfIssuance: null,
        dateOfExpiry: null,
        branchOffices: false,
        //
        settingsName: null,
        titlePositionOfSignatory: null,
        tinOfSignatory: null,
        //
        treasurerName: null,
        treasurerPositionOfSignatory: null,
        treasurerTinOfSignatory: null,
        OCSalesTax: null,
      },
      entityTypeList: [
        {id: 1, name: 'Individual'},
        {id: 2, name: 'Non Individual'},
      ],
      taxpayerClassifications: [],
      psics: [],
      psocs: [],
      fillingMethods: [],
      rules: {
        taxpayerClassificationId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change'}
        ],
        psicId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change'}
        ],
        psocId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change'}
        ],
        fillingMethodId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change'}
        ],
      }
    }
  },
  mounted() {
    this.$store.dispatch('getCompanyLayout').then(response => {
      this.getItem()
      this.getGeneralInfo()
      this.getPsicList()
      this.getPsocList()
      this.getTaxpayerClassifications()
      this.getFillingMethods()
    })
  },
  methods: {
    getGeneralInfo() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/companies/item?companyId=${this.$route.query.companyId}`).then(response => {
        let customFieldsJson = JSON.parse(response.data.item.customFieldsJson)
        this.form.OCSalesTax = customFieldsJson.entityType
        // this.form.OCSalesTax = response.data.list
        loader.hide()
      }).catch(err => {
        loader.hide()
      })
    },
    getItem() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/company-reporting-info/item?companyId=${this.$route.query.companyId}`).then(response => {
        this.form.taxpayerClassificationId = response.data.item.taxpayerClassificationId
        this.form.psicId = response.data.item.psicId
        this.form.psocId = response.data.item.psocId
        this.form.fillingMethodId = response.data.item.fillingMethodId
        this.form.isPsic = response.data.item.isPsic
        this.form.agentName = response.data.item.agentName
        this.form.dateOfIssuance = response.data.item.dateOfIssuance
        this.form.dateOfExpiry = response.data.item.dateOfExpiry
        this.form.branchOffices = response.data.item.branchOffices
        this.form.settingsName = response.data.item.settingsName
        this.form.titlePositionOfSignatory = response.data.item.titlePositionOfSignatory
        this.form.tinOfSignatory = response.data.item.tinOfSignatory
        this.form.treasurerName = response.data.item.treasurerName
        this.form.treasurerPositionOfSignatory = response.data.item.treasurerPositionOfSignatory
        this.form.treasurerTinOfSignatory = response.data.item.treasurerTinOfSignatory
        loader.hide()
      }).catch(err => {
        loader.hide()
      })
    },
    getPsicList() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/psic/list?countryId=${this.companyLayout.countryId}`).then(response => {
        this.psics = response.data.list
        loader.hide()
      }).catch(err => {
        loader.hide()
      })
    },
    getPsocList() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/psoc/list?countryId=${this.companyLayout.countryId}`).then(response => {
        this.psocs = response.data.list
        loader.hide()
      }).catch(err => {
        loader.hide()
      })
    },
    getTaxpayerClassifications() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/taxpayer-classification/list?countryId=${this.companyLayout.countryId}`).then(response => {
        this.taxpayerClassifications = response.data.list
        loader.hide()
      }).catch(err => {
        loader.hide()
      })
    },
    getFillingMethods() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/filling-method/list?countryId=${this.companyLayout.countryId}`).then(response => {
        this.fillingMethods = response.data.list
        loader.hide()
      }).catch(err => {
        loader.hide()
      })
    },
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const payload = {
            taxpayerClassificationId: this.form.taxpayerClassificationId,
            psicId: this.form.isPsic === 1 ? this.form.psicId : null,
            psocId: this.form.isPsic === 0 ? this.form.psocId : null,
            fillingMethodId: this.form.fillingMethodId,
            //
            isPsic: this.form.isPsic,
            //
            agentName: this.form.agentName,
            dateOfIssuance: this.form.dateOfIssuance,
            dateOfExpiry: this.form.dateOfExpiry,
            branchOffices: this.form.branchOffices,
            //
            settingsName: this.form.settingsName,
            titlePositionOfSignatory: this.form.titlePositionOfSignatory,
            tinOfSignatory: this.form.tinOfSignatory,
            //
            treasurerName: this.form.treasurerName,
            treasurerPositionOfSignatory: this.form.treasurerPositionOfSignatory,
            treasurerTinOfSignatory: this.form.treasurerTinOfSignatory
          }
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/company-reporting-info/save?companyId=${this.$route.query.companyId}`, payload).then(response => {

            loader.hide()
          }).catch(err => {
            loader.hide()
          })
        }
      })
    },
    openFillingModal(entityTypeId) {
      this.$refs.fillingModal.openModal(entityTypeId)
    },
    openBranchOfficeModal() {
      this.$refs.branchOfficeModal.openModal()
    },
    routerLink(page) {
      this.$router.push({ name: page, query: { companyId: this.$route.query.companyId }})
    },
  }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper {
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
